import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getUserOptimumProfile = userId =>
  call(websocketFetch, 'get_user_optimum_profile', { user_id: userId });
